var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0259 13.8473L18.5951 17.4157L17.4159 18.5948L13.8476 15.0257C12.5199 16.09 10.8684 16.6689 9.16675 16.6665C5.02675 16.6665 1.66675 13.3065 1.66675 9.1665C1.66675 5.0265 5.02675 1.6665 9.16675 1.6665C13.3067 1.6665 16.6667 5.0265 16.6667 9.1665C16.6692 10.8682 16.0903 12.5196 15.0259 13.8473ZM13.3542 13.229C14.4118 12.1414 15.0025 10.6835 15.0001 9.1665C15.0001 5.94317 12.3892 3.33317 9.16675 3.33317C5.94341 3.33317 3.33341 5.94317 3.33341 9.1665C3.33341 12.389 5.94341 14.9998 9.16675 14.9998C10.6838 15.0022 12.1417 14.4116 13.2292 13.354L13.3542 13.229ZM8.33342 8.33317V5.83317H10.0001V8.33317H12.5001V9.99984H10.0001V12.4998H8.33342V9.99984H5.83342V8.33317H8.33342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.dbd08c505c560c79a9cb875b3702ab39.svg";
export { ForwardRef as ReactComponent };